import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './InventoryTransfers.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_create_inventory_transfer_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { lookupCode?: string, sourceProjectId: number, targetProjectId: number }): Promise<{ reasons?: string[], inventoryTransferId?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.sourceProjectId)) {
      missingRequiredInParams.push('\'sourceProjectId\'');
    }
    if (isNil(inParams.targetProjectId)) {
      missingRequiredInParams.push('\'targetProjectId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/functions/create_inventory_transfer_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

